const getProfileImage = (imageNumber: number) =>
  `https://1240369105.rsc.cdn77.org/matchingmoments/profileimages/image-${imageNumber}.png`;

export default getProfileImage;
